// Componente Loading/Spinner
import { cn } from '../../utils/cn';

interface LoadingProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  fullScreen?: boolean;
}

export function Loading({ size = 'md', className, fullScreen = false }: LoadingProps) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };
  
  const spinner = (
    <div className={cn('flex items-center justify-center', fullScreen && 'min-h-screen', className)}>
      <div
        className={cn(
          'border-4 border-primary-200 dark:border-primary-800 border-t-primary-600 dark:border-t-primary-400 rounded-full animate-spin',
          sizeClasses[size]
        )}
      />
    </div>
  );
  
  return spinner;
}
